import store from "@/store";

export default [
  {
    name: "Works",
    path: "/works",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/equipmentWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "WorkProfile",
    path: "/work/:id",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/equipmentWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  }
];
